import type * as Types from 'app/types/graphql';

import {
  ThemePageSelectFragmentDoc,
  ThemePageMetaSelectFragmentDoc,
  ThemePageParentSelectFragmentDoc,
} from '../fragments/themePage.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ThemePageQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type ThemePageQueryResponse = {
  themePage?: Types.Maybe<
    Pick<
      Types.ThemePage,
      | 'id'
      | 'name'
      | 'type'
      | 'default'
      | 'isGlobal'
      | 'status'
      | 'updatedAt'
      | 'publishedAt'
      | 'handle'
    > & {
      metafields?: Types.Maybe<
        Array<
          Types.Maybe<Pick<Types.ThemePageMeta, 'createdAt' | 'id' | 'key' | 'updatedAt' | 'value'>>
        >
      >;
      parent?: Types.Maybe<Pick<Types.ThemePage, 'id' | 'name' | 'type' | 'status' | 'default'>>;
    }
  >;
};

export const ThemePageDocument = `
    query ThemePage($id: ID!) {
  themePage(id: $id) {
    ...ThemePageSelect
  }
}
    ${ThemePageSelectFragmentDoc}
${ThemePageMetaSelectFragmentDoc}
${ThemePageParentSelectFragmentDoc}`;

export const useThemePageQuery = <TData = ThemePageQueryResponse, TError = unknown>(
  variables: ThemePageQueryVariables,
  options?: UseQueryOptions<ThemePageQueryResponse, TError, TData>,
) => {
  return useQuery<ThemePageQueryResponse, TError, TData>(
    ['ThemePage', variables],
    appFetcher<ThemePageQueryResponse, ThemePageQueryVariables>(ThemePageDocument, variables),
    options,
  );
};

useThemePageQuery.getKey = (variables: ThemePageQueryVariables) => ['ThemePage', variables];
